<template>
  <div>
    <div class="text-center">
      <img
        class="mt-3"
        src="@/assets/friendline01-top.jpg"
        style="max-height: 56px; height: 100%"
      />
    </div>

    <template v-if="loading">
      <v-row :align="'center'" justify="center" style="height: 75vh">
        <div class="text-center">
          <v-progress-circular
            :size="70"
            :width="7"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-row>
    </template>
    <template v-else>
      <div :align="'center'" class="mt-3" justify="center">
        <!-- <div class="text-center">
          <v-btn
            class="px-6"
            :loading="confirmloading"
            @click="clickConfirm"
            color="primary"
            >ยืนยัน</v-btn
          >
        </div> -->
        <div
          class="px-4"
          style="color: white; font-size: 18px; max-width: 450px"
        >
          <span>ขอบคุณที่เพิ่ม Generali Thailand เป็นเพื่อนกับคุณ</span>
          <span>เพื่อรับข่าวสาร ข้อมูลสุขภาพน่ารู้ พร้อมรับสิทธิพิเศษ</span>
          <span>เฉพาะลูกค้า และกิจกรรมสนุกๆ อีกมากมาย</span>
        </div>
        <div class="mt-5">
          <v-btn small @click="clickConfirm">
            <span style="color: #c4261b; font-size: 20px">ตกลง</span>
          </v-btn>
        </div>
        <div
          style="
            display: flex;
            position: absolute;
            bottom: 0px;
            left: 50%;
            transform: translateX(-50%);
          "
        >
          <img
            height="100%"
            src="@/assets/friendline01-bottom.jpg"
            style="
              width: 500px;
              max-width: 500px;
              margin-left: auto;
              margin-right: auto;
            "
          />
        </div>
      </div>
    </template>
    <v-dialog v-model="showaddfriend" fullscreen>
      <v-card class="text-center">
        <v-img
          max-width="600px"
          src="@/assets/addline01.jpg"
          style="margin-left: auto; margin-right: auto; position: relative"
        >
          <div
            class="text-center"
            style="
              position: absolute;
              bottom: 0px;
              left: 50%;
              transform: translate(-50%, 0);
            "
          >
            <v-btn
              class="px-19"
              color="primary myfont"
              large
              rounded
              style="font-size: 20px; padding-left: 25px; padding-right: 25px"
              @click="goToAdd"
            >
              ตกลง
            </v-btn>
          </div>
        </v-img>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      loading: true,
      confirmloading: false,
      showConfirm: false,
      publicPath: process.env.BASE_URL,
      showaddfriend: false,
      lineOaId: process.env.VUE_APP_LINE_OA_ADD,
    };
  },
  async mounted() {
    var vm = this;
    var friendShip = await vm.$liff.getFriendship();
    // https://liff.line.me/1653855836-zg8O046X/?view=SendMessage&pageid=177518292310976&apptype=line&message=orpline23
    if (friendShip.friendFlag) {
      const response = await this.sendMessage();
      if (response == "not_found_user") {
        await vm.$swal.fire({
          text: "ไม่พบข้อมูลผู้ใช้งาน",
        });
        vm.closeWindow();
      } else if (response == "unsuccess") {
        await this.$liff.openWindow({
          url: this.getLinkByOs(),
          external: false,
        });
        vm.closeWindow();
      } else {
        await this.$liff.openWindow({
          url: this.addFriendLink,
          external: false,
        });
        vm.closeWindow();
      }

      vm.loading = false;
    } else {
      vm.loading = false;
      await this.$liff.openWindow({
        url: this.getLinkByOs(),
        external: false,
      });
      this.showaddfriend = true;

      vm.loading = false;
      vm.showConfirm = true;
    }
  },
  computed: {
    query() {
      return this.$store.state.query;
    },
    profile() {
      return this.$store.state.profile;
    },
    sendMessageLink() {
      return `https://line.me/R/oaMessage/${encodeURIComponent(
        this.lineOaId
      )}/?${this.query.message}`;
    },
    addFriendLink() {
      return `https://line.me/R/ti/p/${encodeURIComponent(this.lineOaId)}`;
    },
  },
  methods: {
    getLinkByOs() {
      if (this.$liff.getOS() == "web") {
        return this.addFriendLink;
      } else {
        return this.sendMessageLink;
      }
    },
    async goToAdd() {
      await this.$liff.openWindow({
        url: this.getLinkByOs(),
        external: false,
      });
      this.showaddfriend = false;
    },
    async clickConfirm() {
      var vm = this;
      this.confirmloading = true;
      var friendShip = await vm.$liff.getFriendship();
      if (!friendShip.friendFlag) {
        this.showaddfriend = true;
      } else {
        const response = await this.sendMessage();
        if (response == "not_found_user") {
          await vm.$swal.fire({
            text: "ไม่พบข้อมูลผู้ใช้งาน",
          });
        } else if (response == "unsuccess") {
          vm.goToAdd();
        } else if (response == "success") {
          await this.closeWindow();
          // await this.$liff.openWindow({
          //   url: this.addFriendLink,
          //   external: false,
          // });
        }
      }
      this.confirmloading = false;
    },
    sendMessage() {
      var vm = this;
      return new Promise((resolve) => {
        const apiUrl = this.$store.state.serverUrl;
        const apiToken = this.$store.state.apiToken;
        const apiKey = this.$store.state.serverApiKey;
        const zwizPageToken = this.$store.state.zwizPageToken;

        var url = `${apiUrl}api/generali/send-push-message`;
        var data = {
          page_id: vm.query.pageid,
          user_id: vm.profile.userId + "__" + vm.query.pageid,
          channel: "line",
          type: "bot",
          page_token: zwizPageToken,
          messages: [
            {
              type: "text",
              text: vm.query.message,
            },
          ],
        };
        axios
          .post(url, data, {
            headers: {
              AUTHORIZATION: `Bearer ${apiToken}`,
              "x-api-key": apiKey,
            },
          })
          .then(async (response) => {
            if (response.data.responsecode == 200) {
              resolve("success");
            } else {
              if (response.data.reason) {
                if (response.data.reason == "ไม่พบข้อมูลของ User") {
                  resolve("not_found_user");
                } else {
                  await vm.$swal.fire({
                    text: response.data.reason,
                  });
                  resolve("unsuccess");
                }
              }
            }
          });
      });
    },
    async closeWindow() {
      if (this.$liff && this.$liff.isInClient()) {
        await this.$liff.closeWindow();
      } else {
        window.close();
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
